import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_NHSV_STOCK_RIGHTS_API_ID = 'DASHBOARD/FETCH_NHSV_STOCK_RIGHTS_API';

// The rights an account's user sees in the app (GET /portfolios/rights), from
// the same service. Dates are YYYY-MM-DD; null when NHSV has none yet.
export type StockRight = {
  symbol: string;
  kind: string;
  kind_label: string;
  record_date: string | null;
  ratio: string;
  quantity: number;
  amount: number;
  tax_rate: number;
  date: string | null;
  price: number;
  registered_quantity: number;
  register_from: string | null;
  register_to: string | null;
};

export type StockRightEvent = {
  symbol: string;
  kind: string;
  kind_label: string;
  title: string;
  ex_date: string;
  record_date: string;
};

export type StockRights = {
  available: boolean;
  pending: StockRight[];
  subscriptions: StockRight[];
  received: StockRight[];
  ex_rights: StockRightEvent[];
};

const apiCall = createApiCall(
  FETCH_NHSV_STOCK_RIGHTS_API_ID,
  (params: { account_number: string; symbol?: string }) => ({
    endpoint: generateEndpoint({
      host: '/api/admin/nhsv/stock-rights',
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
